import { render } from "./RedirectToCard.vue?vue&type=template&id=4bc427cb"
import script from "./RedirectToCard.vue?vue&type=script&lang=js"
export * from "./RedirectToCard.vue?vue&type=script&lang=js"

import "./RedirectToCard.vue?vue&type=style&index=0&id=4bc427cb&lang=css"
import "./RedirectToCard.vue?vue&type=style&index=1&id=4bc427cb&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__